export default "<p>© Nica S.r.l. </p>\r\n"